import { useCallback, useEffect, useState } from "react";
import { ShieldAlert, ShieldCheck, RefreshCw } from "lucide-react";

export const AdminFraudAlerts = ({ client, API }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = useCallback(() => {
    setLoading(true);
    client().get(`${API}/admin/fraud-alerts`).then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, [client, API]);

  useEffect(() => { load(); }, [load]);

  if (!data) return <p className="text-sm text-slate-400 py-6">Loading fraud alerts…</p>;

  return (
    <div data-testid="admin-fraud-alerts" className="max-w-4xl">
      <div className="flex items-center justify-between mb-5">
        <p className="text-sm text-slate-500">
          IPs with <strong>{data.threshold}+ clicks</strong> on the same ambassador link in the last <strong>{data.window_hours}h</strong>. High severity = very large volume or a rapid burst.
        </p>
        <button onClick={load} data-testid="fraud-refresh-button"
          className="flex items-center gap-1.5 text-sm font-medium text-slate-500 hover:text-slate-900 transition-colors duration-200">
          <RefreshCw className={`w-4 h-4 ${loading ? "animate-spin" : ""}`} /> Refresh
        </button>
      </div>
      {data.alerts.length === 0 ? (
        <div data-testid="fraud-alerts-empty" className="bg-white border border-slate-200 rounded-lg p-10 text-center">
          <ShieldCheck className="w-8 h-8 text-emerald-500 mx-auto mb-3" />
          <p className="font-medium">No suspicious activity detected</p>
          <p className="text-sm text-slate-500 mt-1">All click patterns look normal right now.</p>
        </div>
      ) : (
        <div className="overflow-x-auto bg-white border border-slate-200 rounded-lg">
          <table className="w-full text-sm min-w-[720px]">
            <thead><tr className="text-left text-xs uppercase tracking-wider text-slate-400 border-b border-slate-200">
              <th className="p-4">Severity</th><th className="p-4">IP address</th><th className="p-4">Ambassador</th><th className="p-4">Clicks</th><th className="p-4">Time span</th><th className="p-4">Last seen</th>
            </tr></thead>
            <tbody>
              {data.alerts.map((a, i) => (
                <tr key={`${a.ip}-${a.handle}`} data-testid={`fraud-alert-row-${i}`} className="border-b border-slate-100">
                  <td className="p-4">
                    <span className={`inline-flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wider px-2.5 py-0.5 rounded-full border ${a.severity === "high" ? "bg-rose-50 text-rose-700 border-rose-200" : "bg-amber-50 text-amber-700 border-amber-200"}`}>
                      <ShieldAlert className="w-3 h-3" /> {a.severity}
                    </span>
                  </td>
                  <td className="p-4 font-mono text-xs">{a.ip}</td>
                  <td className="p-4 font-medium">{a.ambassador_name} <span className="text-slate-400 font-normal font-mono text-xs">/go/{a.handle}</span></td>
                  <td className="p-4 font-semibold">{a.clicks}</td>
                  <td className="p-4 text-slate-500">{a.span_minutes < 60 ? `${a.span_minutes} min` : `${(a.span_minutes / 60).toFixed(1)} h`}</td>
                  <td className="p-4 text-slate-500 text-xs">{new Date(a.last_ts).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
